import React, { useState, useEffect } from 'react';
import { FaRuler, FaDrawPolygon, FaCube, FaTrash, FaUndo } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import '../styles/components/measurement-tools.css';

const MeasurementTools = ({
  measurementMode,
  onModeChange,
  measurements,
  onClearMeasurements,
  onUndo,
  canUndo
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const tools = [
    {
      id: 'distance',
      icon: <FaRuler />,
      title: 'Distance',
      description: 'Measure distance between points'
    },
    {
      id: 'area',
      icon: <FaDrawPolygon />,
      title: 'Area',
      description: 'Measure area of a polygon'
    },
    {
      id: 'volume',
      icon: <FaCube />,
      title: 'Volume',
      description: 'Measure volume (area × height)'
    }
  ];

  const handleModeClick = (mode) => {
    if (measurementMode === mode) {
      onModeChange(null);
    } else {
      onModeChange(mode);
    }
  };

  return (
    <div className={`measurement-tools-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="measurement-tools-header">
        <h3 className="measurement-tools-title">
          Measurement Tools
        </h3>
        <button
          className="measurement-tools-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? <MdClose /> : <FaRuler />}
        </button>
      </div>

      {isExpanded && (
        <>
          <div className="measurement-tools-buttons">
            {tools.map((tool) => (
              <button
                key={tool.id}
                className={`measurement-tool-button ${measurementMode === tool.id ? 'active' : ''}`}
                onClick={() => handleModeClick(tool.id)}
                title={tool.description}
              >
                <span className="measurement-tool-icon">{tool.icon}</span>
                <span className="measurement-tool-label">{tool.title}</span>
              </button>
            ))}
          </div>

          {measurementMode && (
            <div className="measurement-instructions">
              {measurementMode === 'distance' && (
                <p>Click two points to measure distance</p>
              )}
              {measurementMode === 'area' && (
                <p>Click multiple points to create a polygon. Double-click to finish.</p>
              )}
              {measurementMode === 'volume' && (
                <p>Draw a polygon base, then set the height.</p>
              )}
            </div>
          )}

          {measurements && measurements.length > 0 && (
            <div className="measurement-results">
              <div className="measurement-results-header">
                <h4>Measurements</h4>
                <div className="measurement-actions">
                  {canUndo && (
                    <button
                      className="measurement-action-button"
                      onClick={onUndo}
                      title="Undo last measurement"
                    >
                      <FaUndo />
                    </button>
                  )}
                  <button
                    className="measurement-action-button"
                    onClick={onClearMeasurements}
                    title="Clear all measurements"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
              <div className="measurement-results-list">
                {measurements.map((measurement, index) => (
                  <div key={index} className="measurement-result-item">
                    <span className="measurement-result-type">
                      {measurement.type === 'distance' && <FaRuler />}
                      {measurement.type === 'area' && <FaDrawPolygon />}
                      {measurement.type === 'volume' && <FaCube />}
                    </span>
                    <span className="measurement-result-value">
                      {measurement.formattedValue}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MeasurementTools;